import { render, staticRenderFns } from "./DeleteRoomModal.vue?vue&type=template&id=67e8a024&"
import script from "./DeleteRoomModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports